export interface LastCompletedServiceUpdateInput {
    hasUpdateHandler: boolean;
    isStale: boolean;
    selectionValid: boolean;
    canGeneratePlan: boolean;
    isGenerating: boolean;
    sessionExpired: boolean;
    needsReconfirm: boolean;
    planFieldsEdited: boolean;
}

export interface LastCompletedServiceUpdateState {
    canUpdate: boolean;
    reason: string | null;
}

const blockedReason = (input: LastCompletedServiceUpdateInput): string | null => {
    if (input.sessionExpired)
        return 'The session has ended. Start the vehicle step again to update the plan.';
    if (input.needsReconfirm) return 'The vehicle needs confirming before the plan can be updated.';
    if (!input.canGeneratePlan)
        return 'Updating is unavailable until a plan can be generated for this vehicle.';
    if (input.planFieldsEdited)
        return 'Use Update plan in the plan settings to apply the duration and MOT changes too.';
    if (!input.hasUpdateHandler) return 'Choose a plan duration and MOT option to update the plan.';
    if (!input.selectionValid)
        return 'Complete the last completed service details to update the plan.';
    return null;
};

export const lastCompletedServiceUpdateState = (
    input: LastCompletedServiceUpdateInput
): LastCompletedServiceUpdateState => {
    if (input.isGenerating) return { canUpdate: false, reason: null };
    const reason = blockedReason(input);
    return { canUpdate: reason === null && input.isStale, reason };
};
